module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('admin-layout', [_c('div', {
    staticClass: "content",
    attrs: {
      "slot": "main"
    },
    slot: "main"
  }, [_c('div', {
    staticClass: "content-header"
  }, [_c('h3', [_vm._v("Campaigns")])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped"
  }, [_c('tbody', [_vm._l((_vm.campaignsByVendor), function(item) {
    return [(item.type == 'provider') ? [_c('tr', [(item.type == 'provider') ? _c('th', {
      staticClass: "vendor-header",
      attrs: {
        "colspan": "4"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleShowProviderModal(item.provider)
        }
      }
    }, [_vm._v(_vm._s(item.name))])]) : _vm._e()]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Campaign Type")]), _vm._v(" "), _c('th', [_vm._v("Active")]), _vm._v(" "), _c('th', [_vm._v("Test")])])] : [_c('tr', [(item.type == 'campaign') ? _c('th', {
      staticClass: "campaign-name"
    }, [(item.campaign_type == 'google') ? _c('span', [_c('i', {
      staticClass: "fa fa-google"
    }), _vm._v(" - ")]) : _vm._e(), _vm._v(" "), (item.campaign_type == 'facebook') ? _c('span', [_c('i', {
      staticClass: "fa fa-facebook"
    }), _vm._v(" - ")]) : _vm._e(), _vm._v(" "), (item.campaign_type == 'ping-post') ? _c('span', [_c('i', {
      staticClass: "fa fa-money"
    }), _vm._v(" - ")]) : _vm._e(), _vm._v(" "), (item.campaign_type == 'appointment') ? _c('span', [_c('i', {
      staticClass: "fa fa-calendar"
    }), _vm._v(" - ")]) : _vm._e(), _vm._v(" "), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          $event.stopPropagation();
          return _vm.toggleShowCampaignModal(item.id)
        }
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('tags-widget', {
      attrs: {
        "tagsDb": _vm.tagsDb,
        "readOnly": true,
        "tags": item.tags
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 'campaign') ? _c('td', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(item.campaign_type))]) : _vm._e(), _vm._v(" "), (item.type == 'campaign') ? _c('td', [_c('yes-no', {
      attrs: {
        "ok": item.is_active
      }
    })], 1) : _vm._e(), _vm._v(" "), (item.type == 'campaign') ? _c('td', [_c('yes-no', {
      attrs: {
        "ok": item.is_test
      }
    })], 1) : _vm._e()])]]
  })], 2)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modals"
    },
    slot: "modals"
  }, [(_vm.showCampaignModal) ? _c('campaign-modal', {
    attrs: {
      "campaign": _vm.campaign
    },
    on: {
      "close": _vm.closeCampaignModal
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showProviderModal) ? _c('provider-modal', {
    attrs: {
      "provider": _vm.provider
    },
    on: {
      "close": _vm.closeProviderModal
    }
  }) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26ca05e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/private/CampaignsSettings.vue
// module id = 650
// module chunks = 0